import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Alert, message, notification, Button } from 'antd'

const defaultState = {
  feedbackTitle: null,
  feedbackMessage: null,
  feedbackType: null,
  styleFeedbackType: 'info',
  messageTimestamp: null,
  btnLabel: null,
}

class Feedback extends Component {
  state = {
    ...defaultState,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.messageTimestamp !== this.state.messageTimestamp) {
      return this.setState({
        ...defaultState,
        ...nextProps,
      }, () => this.renderUserFeedback())
    }
    return null
  }
  showMessage = () => {
    switch (this.state.styleFeedbackType) {
      case 'info': {
        return message.info(this.state.feedbackMessage)
      }
      case 'error': {
        return message.error(this.state.feedbackMessage)
      }
      case 'success': {
        return message.success(this.state.feedbackMessage)
      }
      default: {
        return message.warning(this.state.feedbackMessage)
      }
    }
  }
  showNotification = () => {
    const btn = this.state.btnLabel ? (
      (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            notification.close()
            this.state.onClick()
          }}
        >
          {this.state.btnLabel}
        </Button>
      )
    ) : null
    notification.config({
      placement: 'bottomRight',
    })
    switch (this.state.styleFeedbackType) {
      case 'info': {
        return notification.info({
          message: this.state.feedbackTitle || 'Informação',
          description: this.state.feedbackMessage,
          btn,
        })
      }
      case 'error': {
        return notification.error({
          message: this.state.feedbackTitle || 'Oops',
          description: this.state.feedbackMessage,
          btn,
        })
      }
      case 'success': {
        return notification.success({
          message: this.state.feedbackTitle || 'Confirmação',
          description: this.state.feedbackMessage,
          btn,
        })
      }
      default: {
        return notification.warning({
          message: this.state.feedbackTitle || 'Aviso',
          description: this.state.feedbackMessage,
        })
      }
    }
  }
  renderUserFeedback = () => {
    switch (this.state.feedbackType) {
      case 'MESSAGE': {
        return this.showMessage()
      }
      case 'NOTIFICATION': {
        return this.showNotification()
      }
      case 'ALERT': {
        return (
          <Alert
            message={this.state.feedbackTitle}
            description={this.state.feedbackMessage}
            type={this.state.styleFeedbackType}
            showIcon
          />
        )
      }
      default: {
        return null
      }
    }
  }
  render() {
    return (
      <div style={{ display: 'hidden' }} />
    )
  }
}

const mapStateToProps = state => ({
  feedbackMessage: state.application.feedbackMessage,
  feedbackTitle: state.application.feedbackTitle,
  feedbackType: state.application.feedbackType,
  styleFeedbackType: state.application.styleFeedbackType,
  messageTimestamp: state.application.messageTimestamp,
  btnLabel: state.application.btnLabel,
  onClick: state.application.onClick,
  status: state.application.status,
})

export default connect(mapStateToProps)(Feedback)
